import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import Axios from "axios";
import moment from "moment";
import { Collapse, Input } from "antd";
import { Modal, Spinner, Button } from "react-bootstrap";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import JSONPretty from "react-json-pretty";

const { Panel } = Collapse;

function DetailsModal(props) {
  const {
    showDetails,
    setShowDetails,
    selectedUser,
    accessToken,
    refreshToken,
    orderId,
  } = props;

  const [baseProductList, setBaseProductList] = useState([]);
  const [freeProductList, setFreeProductList] = useState([]);
  const [orderInfo, setOrderInfo] = useState([]);
  const [deliveryStatus, setDeliveryStatus] = useState([]);
  const [showfreeProduct, setShowFreeProducts] = useState(false);
  const [loading, setLoading] = useState(false);

  const [subtotal, setSubtotal] = useState(0);
  const [discount, setDiscount] = useState(0);

  const dataBaseProduct = React.useMemo(() => baseProductList, [
    baseProductList,
  ]);
  const dataFreeProduct = React.useMemo(() => freeProductList, [
    freeProductList,
  ]);
  const columns = React.useMemo(
    () => [
      {
        Header: "#",
        accessor: (row, index) => (
          <div className="d-flex align-items-center pl-4">
            <div>
              <h4 className="text-dark-75 font-weight-bolder mb-1 font-size-sm">
                {index + 1}
              </h4>
            </div>
          </div>
        ),
        minWidth: 30,
        width: 30,
      },
      {
        Header: "Code",
        accessor: "product_code",
        paddingLeft: "0px",
      },
      {
        Header: "Barcode",
        accessor: "barcode",
        paddingLeft: "0px",
      },
      {
        Header: "Name",
        accessor: "product_name",
        paddingLeft: "0px",
      },
      {
        Header: "Quantity",
        accessor: "quantity",
        paddingLeft: "0px",
      },
      {
        Header: "Disc. Rate",
        accessor: (data) => Math.round(data.rate),
        paddingLeft: "0px",
      },
      {
        Header: "Discount",
        accessor: (data) => Math.round(data.discount),
        paddingLeft: "0px",
      },
      {
        Header: "Vat",
        paddingLeft: "0px",
        accessor: (data) => (
          <>
            {Math.round(
              ((data.unit_price * data.sal_vat_percent) / 100) * data.quantity
            )}
          </>
        ),
      },
      {
        Header: "Total",
        accessor: (data) => (
          <>{Math.round(data.rate * data.quantity + Number(data.discount))}</>
        ),
        paddingLeft: "0px",
      },
    ],
    []
  );
  // Get Order Product List
  const getOrderProductList = async () => {
    setLoading(true);
    try {
      const { data } = await Axios.get(
        `${process.env.REACT_APP_API_URL}/order-btoc/orderProductListFromOrderId/${orderId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
            refreshToken: refreshToken,
          },
        }
      );
      if (!data.error) {
        setBaseProductList(data.data.baseProductData);
        setOrderInfo(data.data.orderInfo);
        setDeliveryStatus(data.data.status);

        if (data.data.freeProductData.length > 0) {
          setFreeProductList(data.data.freeProductData);
          setShowFreeProducts(true);
        }
        const subTotal = data.data.baseProductData.reduce((acc, item) => {
          const itemTotal = Math.round(
            item.rate * item.quantity + Number(item.discount)
          );

          return itemTotal + acc;
        }, 0);
        setSubtotal(Math.round(subTotal));

        const discount = data.data.baseProductData.reduce(
          (acc, item) => Math.round(Number(item.discount) + acc),
          0
        );
        setDiscount(Math.round(discount));
        setLoading(false);
      } else {
        setShowDetails(false);
        swal({
          title: data.message,
          icon: "error",
        });
      }
    } catch (error) {
      setShowDetails(false);
      swal({
        title: error.response.data.message,
        icon: "error",
      });
    }
  };

  console.log("discount: ", discount);

  useEffect(() => {
    getOrderProductList();
  }, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    state: { pageIndex, pageSize, globalFilter },
    setGlobalFilter,
  } = useTable(
    { columns, data: dataBaseProduct },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps: getTableProps2,
    getTableBodyProps: getTableBodyProps2,
    headerGroups: headerGroups2,
    prepareRow: prepareRow2,
    page: page2,
    state: {
      pageIndex: pageIndex2,
      pageSize: pageSize2,
      globalFilter: globalFilter2,
    },
    setGlobalFilter: setGlobalFilter2,
  } = useTable(
    { columns, data: dataFreeProduct },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  return (
    <Modal
      show={showDetails}
      onHide={() => setShowDetails(false)}
      size="xl"
      aria-labelledby="example-modal-sizes-title-lg"
      centered
    >
      {/* Base Products */}
      <div className="card card-custom">
        <div className="card-header border-0 py-5 d-flex justify-content-between">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark d-block">
              Base Product Data
            </span>
          </h3>
        </div>

        {loading ? (
          <div className="card py-5">
            <div className="container">
              <div className="row justify-content-center">
                <Button variant="primary" disabled>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Loading...
                </Button>
              </div>
            </div>
          </div>
        ) : (
          <div className="card-body py-0">
            <div className="tab-content">
              <div className="table-responsive">
                <table
                  {...getTableProps()}
                  className="table table-head-custom table-head-bg table-borderless table-vertical-center"
                >
                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => (
                          <th
                            {...column.getHeaderProps(
                              column.getSortByToggleProps({
                                style: {
                                  minWidth: column.minWidth,
                                  width: column.width,
                                  paddingLeft: column.paddingLeft,
                                },
                              })
                            )}
                            className="datatable-cell datatable-cell-sort datatable-cell-sorted"
                          >
                            <span className="text-dark-75">
                              {column.render("Header")}
                            </span>
                            <span>
                              {column.isSorted ? (
                                column.isSortedDesc ? (
                                  <i
                                    className="flaticon2-arrow-up"
                                    style={{
                                      color: "#3699FF",
                                      fontSize: ".6rem",
                                      marginLeft: "10px",
                                    }}
                                  ></i>
                                ) : (
                                  <i
                                    className="flaticon2-arrow-down"
                                    style={{
                                      color: "#3699FF",
                                      fontSize: ".6rem",
                                      marginLeft: "10px",
                                    }}
                                  ></i>
                                )
                              ) : (
                                ""
                              )}
                            </span>
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps()}>
                    {page.map((row) => {
                      prepareRow(row);
                      return (
                        <tr
                          {...row.getRowProps()}
                          className="text-dark-75 mb-1"
                          style={{ borderBottom: "1px dashed #EBEDF3" }}
                        >
                          {row.cells.map((cell) => {
                            return (
                              <td
                                {...cell.getCellProps()}
                                className="pl-0 py-3 font-size-sm "
                              >
                                {cell.render("Cell")}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Free Products */}
      {showfreeProduct && (
        <div className="card card-custom">
          <div className="card-header border-0 py-5 d-flex justify-content-between">
            <h3 className="card-title align-items-start flex-column">
              <span className="card-label font-weight-bolder text-dark d-block">
                Free Product Data
              </span>
            </h3>
          </div>

          {loading ? (
            <div className="card py-5">
              <div className="container">
                <div className="row justify-content-center">
                  <Button variant="primary" disabled>
                    <Spinner
                      as="span"
                      animation="grow"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    Loading...
                  </Button>
                </div>
              </div>
            </div>
          ) : (
            <div className="card-body py-0">
              <div className="tab-content">
                <div className="table-responsive">
                  <table
                    {...getTableProps2()}
                    className="table table-head-custom table-head-bg table-borderless table-vertical-center"
                  >
                    <thead>
                      {headerGroups2.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map((column) => (
                            <th
                              {...column.getHeaderProps(
                                column.getSortByToggleProps({
                                  style: {
                                    minWidth: column.minWidth,
                                    width: column.width,
                                    paddingLeft: column.paddingLeft,
                                  },
                                })
                              )}
                              className="datatable-cell datatable-cell-sort datatable-cell-sorted"
                            >
                              <span className="text-dark-75">
                                {column.render("Header")}
                              </span>
                              <span>
                                {column.isSorted ? (
                                  column.isSortedDesc ? (
                                    <i
                                      className="flaticon2-arrow-up"
                                      style={{
                                        color: "#3699FF",
                                        fontSize: ".6rem",
                                        marginLeft: "10px",
                                      }}
                                    ></i>
                                  ) : (
                                    <i
                                      className="flaticon2-arrow-down"
                                      style={{
                                        color: "#3699FF",
                                        fontSize: ".6rem",
                                        marginLeft: "10px",
                                      }}
                                    ></i>
                                  )
                                ) : (
                                  ""
                                )}
                              </span>
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody {...getTableBodyProps2()}>
                      {page2.map((row) => {
                        prepareRow2(row);
                        return (
                          <tr
                            {...row.getRowProps()}
                            className="text-dark-75 mb-1"
                            style={{ borderBottom: "1px dashed #EBEDF3" }}
                          >
                            {row.cells.map((cell) => {
                              return (
                                <td
                                  {...cell.getCellProps()}
                                  className="pl-0 py-3 font-size-sm "
                                >
                                  {cell.render("Cell")}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      <div className="card p-5 border-0">
        <div className="row p-5">
          <div className="col-md-6 mb-3">
            {orderInfo.pickup_address ? (
              <>
                <h6>Pickup Address</h6>
                <p className="mb-0">
                  <span>
                    <strong>Order Code: </strong>
                  </span>
                  {orderInfo.order_code}
                </p>
                <p className="mb-0">
                  <span>
                    <strong>Name: </strong>
                  </span>
                  {orderInfo.name}
                </p>
                <p className="mb-0">
                  <span>
                    <strong>Phone: </strong>
                  </span>
                  {orderInfo.PHONE}
                </p>
                <p className="mb-0">
                  <span>
                    <strong>Address: </strong>
                  </span>
                  {orderInfo.pickup_address}
                </p>
              </>
            ) : (
              <>
                <h6>Order Information</h6>
                <p className="mb-0">
                  <span>
                    <strong>Order Code: </strong>
                  </span>
                  {orderInfo.order_code}
                </p>
                <p className="mb-0">
                  <span>
                    <strong>Name: </strong>
                  </span>
                  {selectedUser.customer_name}
                </p>
                <p className="mb-0">
                  <span>
                    <strong>Phone: </strong>
                  </span>
                  {orderInfo.order_phone}
                </p>
                <p className="mb-0">
                  <span>
                    <strong>Address: </strong>
                  </span>
                  {orderInfo.delivery_address_text}
                </p>
              </>
            )}
            <p className="mb-0">
              <span>
                <strong>Store: </strong>
              </span>
              {selectedUser.store_name}
            </p>
            <p className="mb-0">
              <span>
                <strong>Order At: </strong>
              </span>
              {moment(orderInfo.order_at).format("DD-MM-YYYY - hh:mm a")}
            </p>
            <p className="mb-0">
              <span>
                <strong>Order Via: </strong>
              </span>
              {orderInfo.order_via}
            </p>
            <p className="mb-0">
              <span>
                <strong>Delivery Method: </strong>
              </span>
              {orderInfo.delivery_or_pickup}
            </p>
            <p className="mb-0">
              <span>
                <strong>Payment Method: </strong>
              </span>
              {orderInfo.payment_method_id == 1
                ? "Online Payment"
                : "Cash on Delivery"}
            </p>
          </div>
          <div className="col-md-6 mb-3">
            <div className="">
              <div
                className="clearfix mb-2"
                style={{ borderBottom: "1px solid #cfcfcf" }}
              >
                <h6 className="float-start text-dark">Order Summary</h6>
                <h6 className="float-end">Price</h6>
              </div>

              <div className="d-flex justify-content-between">
                <div>
                  <h6>Sub Total</h6>
                </div>
                <div className="text-end">
                  <h6>
                    <span style={{ fontFamily: "roboto" }}>৳</span>
                    {subtotal}
                  </h6>
                </div>
              </div>
              <div className="d-flex justify-content-between">
                <div>Discount</div>
                <div className="text-end">
                  <span style={{ fontFamily: "roboto" }}>৳</span>
                  {Number(orderInfo.discount) + Number(discount)}
                </div>
              </div>
              {orderInfo.balance_used > 0 && (
                <div className="d-flex justify-content-between">
                  <div>Balance Used</div>
                  <div className="text-end">
                    <span style={{ fontFamily: "roboto" }}>৳</span>
                    {orderInfo.balance_used}
                  </div>
                </div>
              )}
              <div className="d-flex justify-content-between">
                <div>Delivery Charge</div>
                <div className="text-end">
                  <span style={{ fontFamily: "roboto" }}>৳</span>{" "}
                  {orderInfo.delivery_charge}
                </div>
              </div>
              <div className="d-flex justify-content-between mt-3">
                <div>
                  <h6>Grand Total</h6>
                </div>
                <div className="text-end">
                  <h6>
                    <span style={{ fontFamily: "roboto" }}>৳</span>{" "}
                    {orderInfo.grand_total}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card p-5 border-0">
        <div className="row p-5">
          <div className="col-md-4">
            <div className="">
              <h3>Delivery Status Tracker</h3>
              <ul className="sessions">
                {deliveryStatus.map((item, index) => (
                  <li key={index}>
                    <div className="time">
                      {item.event_name === "Pending"
                        ? "Order Placed"
                        : item.event_name}
                    </div>
                    <p>
                      {moment(item.created_at).format("MMMM DD, YYYY, hh:mm a")}
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="col-md-8">
            <Collapse accordion>
              <Panel
                header="Retail System Request"
                key="1"
                style={{ overflow: "auto" }}
              >
                <JSONPretty
                  id="json-pretty"
                  data={orderInfo.retail_system_request_body}
                ></JSONPretty>
              </Panel>
              <Panel
                header="Retail System Response"
                key="2"
                style={{ overflow: "auto" }}
              >
                <JSONPretty
                  id="json-pretty"
                  data={orderInfo.retail_system_response}
                ></JSONPretty>
              </Panel>
            </Collapse>
          </div>
        </div>
      </div>

      <Modal.Footer className="border-0 shadow-0">
        <div>
          <button
            type="button"
            onClick={() => setShowDetails(false)}
            className="btn btn-primary btn-elevate"
          >
            Cancel
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default DetailsModal;
